module.exports = __webpack_public_path__ + "static/media/program_slider_phone3.39c75e59.png";